import createReactComponent from '../createReactComponent';
export default createReactComponent('currency-yen', 'IconCurrencyYen', [
  ['path', { d: 'M12 19v-7l-5 -7m10 0l-5 7', key: 'svg-0' }],
  ['path', { d: 'M8 17l8 0', key: 'svg-1' }],
  ['path', { d: 'M8 13l8 0', key: 'svg-2' }],
]);
